import { FrequencyDetails } from "../../components/individual/applications/invocation-schedules/models";
import { FrequencyDetailsHealth } from "../../components/user/reports/installed-application/models";

export function getFrequencyText(freqDetails: FrequencyDetails | FrequencyDetailsHealth | any, ): string {
    // weekday - short label
    const weekdayShortMap: Record<string, string> = {
        Monday: "Mon",
        Tuesday: "Tue",
        Wednesday: "Wed",
        Thursday: "Thu",
        Friday: "Fri",
        Saturday: "Sat",
        Sunday: "Sun",
    };

    // ordinal suffix (1st, 2nd, 3rd, 4th...)
    const toOrdinal = (num: number) => {
        if (!num && num !== 0) return "";
        const suffix =
            num % 10 === 1 && num % 100 !== 11
                ? "st"
                : num % 10 === 2 && num % 100 !== 12
                ? "nd"
                : num % 10 === 3 && num % 100 !== 13
                ? "rd"
                : "th";
        return `${num}${suffix}`;
    };
    const freq = freqDetails;
    if (!freq) return "Daily";

    // daily
    if (freq.frequency === "daily") {
        return "Daily";
    }

    // weekly
    if (freq.frequency === "weekly") {
        const days = Array.isArray(freq.days_of_week)
                ? freq.days_of_week.map(d => weekdayShortMap[d] || d).join(", ")
                : freq.days_of_week || "";
        return `Every ${days}`;
    }

    // monthly
    if (freq.frequency === "monthly") {
        const weekOfMonth = freq.week_of_month?.trim() || "";

        // monthly - week + day (e.g., "First Monday")
        if (weekOfMonth) {
            const day = Array.isArray(freq.days_of_week)
                ? freq.days_of_week.join(", ")
                : freq.days_of_week || "";
            return `${weekOfMonth} ${day} of each month.`;
        }

        // monthly - specific dates
         const days = Array.isArray(freq.days_of_month)
            ? freq.days_of_month.map((d: number) => toOrdinal(d)).join(", ")
            : freq.days_of_month || "";

        return `${days} of each month.`;
    }

    return "Daily";
}
